import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdmin } from '../hooks/useAdmin';
import { LoadingScreen } from '../../../components/LoadingScreen/LoadingScreen';

export const AdminRoute = ({ children }) => {
  const { isAdmin, isLoading } = useAdmin();

  if (isLoading) {
    return <LoadingScreen isLoading={true} />;
  }

  if (!isAdmin) {
    return <Navigate to="/explore" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
